module.exports = __webpack_public_path__ + "media/images/landing--c84af174.png";